import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Icon from '@/utilities/client-components/components/Icon/Icon'
import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledNewFlag = styled.div`
  min-height: 20px;
  min-width: 40px;
  position: absolute;
  top: -7px;
  right: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const StyledLabel = styled.div`
  color: ${(props: any) => themeUtilities.getRgbaColor(props.theme, 'newFlag.color') || 'white'};
  text-align: center;
  font-size: 11px;
  z-index: 2;
  padding: 1px 5px;
`
const StyledBackgroundIcon = styled(Icon)`
  width: 100%;
  height: 100%;
  position: absolute;
  fill: ${(props: any) => themeUtilities.getRgbaColor(props.theme, 'newFlag.iconColor') || '#6C953C'};
  filter: ${(props: any) => {
    // Check for backwards compatability (say if for some reason core.base-theme is outdated)
    if (props.theme.newFlag) {
      return props.theme.newFlag.shadow
        ? `drop-shadow(${props.theme.newFlag.shadow.offsetX}px ${props.theme.newFlag.shadow.offsetY}px ${
            props.theme.newFlag.shadow.blur
          }px ${themeUtilities.getRgbaColor(props.theme, 'newFlag.shadow.color')})`
        : 'none'
    } else {
      return `drop-shadow(1px 1px 1px rgb(0 0 0 / 30%))`
    }
  }};
  z-index: 1;
  top: 0;
  left: 0;
`

interface NewFlagProps {
  className?: string
}

const NewFlag = (className: NewFlagProps) => {
  const { t } = useTranslation('client')

  return (
    // @ts-expect-error
    <StyledNewFlag name={'icon-new'} className={className}>
      <StyledLabel>{t('client:NewFlag.new')}</StyledLabel>
      {/* @ts-expect-error */}
      <StyledBackgroundIcon name={'icon-new'} preserveAspectRatio={'none'} />
    </StyledNewFlag>
  )
}

NewFlag.displayName = 'NewFlag'

export default NewFlag
